import styled, { css } from 'styled-components';
import { theme, palette } from 'styled-tools';

interface FileWrapperProps {
  height?: number;
  backGroundColor?: string;
  boarderColor?: string;
  color?: string;
  fontStyle?: string;
  radius?: number;
}

export const FileWrapper = styled.div<FileWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  text-align: center;
  height: ${(props) => (props.height ? props.height : css`64`)}px;
  line-height: ${(props) => (props.height ? props.height : css`64`)}px;
  border-radius: ${(props) => (props.radius ? props.radius : '4')}px;
  background-color: ${(props) =>
    props.backGroundColor
      ? palette(props.backGroundColor)
      : palette('blue_900')};
  color: ${(props) =>
    props.color ? palette(props.color) : palette('gray_opacity_50')};

  ${(props) =>
    props.boarderColor
      ? css`
          border: 1px solid ${palette(props.boarderColor)};
        `
      : css`
          border: 0;
        `}
  ${(props) =>
    props.fontStyle
      ? css`
          ${theme(`fontStyle.${props.fontStyle}`)}
        `
      : css`
          ${theme(`fontStyle.body1_bold`)}
        `}
`;

export const InputFile = styled.input`
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  cursor: pointer;
  left: 0;
`;
